import Title from "@/components/common/Title";
import { ui } from "@patient-watch/ui";
import { selectCliniciansStatisticsQueryOptions } from "@/features/admin/api/selectCliniciansStatistics";
import { CreatedDiairesSparkChart, DiariesByTabSparkChart } from "@patient-watch/charts";
import { allDiariesQueryOptions } from "@/features/diaries/api";
import { selectProfileByIdQueryOptions } from "@/features/profile/api/selectProfile";
import { createFileRoute } from "@tanstack/react-router";

const StatisticsPage = () => {
    const { cliniciansStats, cliniciansProfiles } = Route.useLoaderData();

    return (
        <div className="lg-width">
            <Title words="Clinicians Statistics" />
            <section className="flex md:flex-row flex-col gap-4">
                <ui.Card className="w-full">
                    <ui.CardHeader>
                        <ui.CardTitle>Created by You</ui.CardTitle>
                    </ui.CardHeader>
                    <ui.CardContent className="flex flex-col items-center">
                        <CreatedDiairesSparkChart
                            cliniciansStats={[...cliniciansStats]
                                .sort((a, b) =>
                                    a.created_at < b.created_at ? -1 : a.created_at > b.created_at ? 1 : 0
                                )
                                .filter((cs) => cs.clinician_id === cliniciansProfiles.user_id)}
                        />
                    </ui.CardContent>
                </ui.Card>
                <ui.Card className="w-full">
                    <ui.CardHeader>
                        <ui.CardTitle>Managed by You</ui.CardTitle>
                    </ui.CardHeader>
                    <ui.CardContent className="flex flex-col items-center">
                        <DiariesByTabSparkChart
                            diaryBreakdown={[...cliniciansStats].sort((a, b) =>
                                a.created_at < b.created_at ? -1 : a.created_at > b.created_at ? 1 : 0
                            )}
                        />
                    </ui.CardContent>
                </ui.Card>
            </section>
        </div>
    );
};

export const Route = createFileRoute("/_app/statistics")({
    component: StatisticsPage,
    loader: async ({ context }) => {
        const cliniciansStats = await context?.queryClient.ensureQueryData(selectCliniciansStatisticsQueryOptions());
        const cliniciansProfiles = await context?.queryClient.ensureQueryData(
            selectProfileByIdQueryOptions(context.auth.id)
        );
        const diaries = await context.queryClient.ensureQueryData(allDiariesQueryOptions());

        return { cliniciansStats, cliniciansProfiles, diaries };
    },
});
